import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { useTranslation } from "gatsby-plugin-react-i18next"

import Tabs from "@material-ui/core/Tabs"
import Tab from "@material-ui/core/Tab"

import Input from "./input"

import useStyles from "./tabs.style"
import { Hidden } from "@material-ui/core"
import Link from "../general/Link"

export default ({ selected, categoryName }) => {
  // for now we dont have i18n on categories
  // a contentful bug requires us to do the filtering for categories
  const data = useStaticQuery(graphql`
    query BlogCategoriesQuery {
      allContentfulSubcategory(filter: { node_locale: { eq: "fr" } }) {
        nodes {
          id
          name
          seo {
            slug
          }
          category {
            name
          }
        }
      }
    }
  `)
  const { t } = useTranslation()
  const classes = useStyles()
  const categories = data.allContentfulSubcategory.nodes.filter(
    ({ category }) => category.name === categoryName
  )
  let selectedTab = 0
  if (selected) {
    selectedTab = categories.findIndex(c => c.name === selected) + 1
  }

  const [value, setValue] = React.useState(selectedTab)
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [menuIndexOpened, setMenuIndexOpened] = React.useState(null)
  const [category, setCategory] = React.useState(null)
  const [dropdown, setDropdown] = React.useState(false)

  const onChangeText = text => {
    setCategory(text)
    setDropdown(true)
  }

  const handleClick = (event, index) => {
    setAnchorEl(event.currentTarget)
    setMenuIndexOpened(index)
  }

  const handleClose = () => {
    setAnchorEl(null)
    setMenuIndexOpened(null)
  }

  const onTabPress = newValue => {
    handleClose()
    setValue(newValue)
  }

  return (
    <div className={classes.root}>
      <Hidden lgUp>
        <div className={classes.inputWrapper}>
          <Input
            dropdown
            items={categories}
            onDropdownItemClick={value => setCategory(value)}
            inputProps={{
              id: "country_input",
              type: "text",
              placeholder: !selectedTab ? t("common.allCategories") : selected,
              value: category,
              onChange: onChangeText,
            }}
          />
        </div>
      </Hidden>
      <Hidden mdDown>
        <Tabs
          value={value}
          indicatorColor="primary"
          textColor="primary"
          centered
        >
          <Link
            style={{ color: "initial" }}
            href={`/${categories[0]?.category?.name === "Blog" ? "blog/" : ""}`}
          >
            <Tab
              label={t("common.allCategories")}
              onClick={() => onTabPress(0)}
            />
          </Link>
          {categories.map((category, index) => (
            <Link
              style={{ color: "initial" }}
              href={`/${category.category.name === "Blog" ? "blog/" : ""}${
                category.seo.slug
              }`}
            >
              <Tab
                label={category.name}
                onClick={() => onTabPress(index + 1)}
              />
            </Link>
          ))}
          {/* <Tab
          className={classes.menuButton}
          label="Le mariage musulman"
          component={Button}
          aria-controls="mariage-menu"
          aria-haspopup="true"
          onClick={e => handleClick(e, 1)}
          endIcon={<KeyboardArrowDownIcon />}
          disableRipple
          disableFocusRipple
        />

        <Tab
          className={classes.menuButton}
          label="Le couple et le musulman"
          component={Button}
          aria-controls="couple-menu"
          aria-haspopup="true"
          onClick={e => handleClick(e, 2)}
          endIcon={<KeyboardArrowDownIcon />}
          disableRipple
          disableFocusRipple
        />

        <Tab
          className={classes.menuButton}
          label="Le comportement"
          component={Button}
          aria-controls="comportement-menu"
          aria-haspopup="true"
          onClick={e => handleClick(e, 3)}
          endIcon={<KeyboardArrowDownIcon />}
          disableRipple
          disableFocusRipple
        />

        <Tab
          className={classes.menuButton}
          label="La science"
          component={Button}
          aria-controls="science-menu"
          aria-haspopup="true"
          onClick={e => handleClick(e, 4)}
          endIcon={<KeyboardArrowDownIcon />}
          disableRipple
          disableFocusRipple
        />

        <Tab
          className={classes.menuButton}
          label="Histoire"
          component={Button}
          aria-controls="histoire-menu"
          aria-haspopup="true"
          onClick={e => handleClick(e, 5)}
          endIcon={<KeyboardArrowDownIcon />}
          disableRipple
          disableFocusRipple
        /> */}
        </Tabs>
      </Hidden>

      {/* <Menu
        id="mariage-menu"
        classes={{ paper: classes.menuWrapper }}
        anchorEl={anchorEl}
        keepMounted
        open={menuIndexOpened === 1}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <MenuItem
          classes={{ root: classes.menuItem }}
          onClick={() => onTabPress(1)}
        >
          Toutes les sous-catégories
        </MenuItem>
        <MenuItem
          classes={{ root: classes.menuItem }}
          onClick={() => onTabPress(1)}
        >
          La rencontre
        </MenuItem>
        <MenuItem
          classes={{ root: classes.menuItem }}
          onClick={() => onTabPress(1)}
        >
          La vie de couple
        </MenuItem>
        <MenuItem
          classes={{ root: classes.menuItem }}
          onClick={() => onTabPress(1)}
        >
          La sexualité
        </MenuItem>
      </Menu>

      <Menu
        id="couple-menu"
        classes={{ paper: classes.menuWrapper }}
        anchorEl={anchorEl}
        keepMounted
        open={menuIndexOpened === 2}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <MenuItem
          classes={{ root: classes.menuItem }}
          onClick={() => onTabPress(2)}
        >
          Couple
        </MenuItem>
        <MenuItem
          classes={{ root: classes.menuItem }}
          onClick={() => onTabPress(2)}
        >
          La rencontre
        </MenuItem>
        <MenuItem
          classes={{ root: classes.menuItem }}
          onClick={() => onTabPress(2)}
        >
          La vie de couple
        </MenuItem>
        <MenuItem
          classes={{ root: classes.menuItem }}
          onClick={() => onTabPress(2)}
        >
          La sexualité
        </MenuItem>
      </Menu>

      <Menu
        id="comportement-menu"
        classes={{ paper: classes.menuWrapper }}
        anchorEl={anchorEl}
        keepMounted
        open={menuIndexOpened === 3}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <MenuItem
          classes={{ root: classes.menuItem }}
          onClick={() => onTabPress(3)}
        >
          Comportement
        </MenuItem>
        <MenuItem
          classes={{ root: classes.menuItem }}
          onClick={() => onTabPress(3)}
        >
          La rencontre
        </MenuItem>
        <MenuItem
          classes={{ root: classes.menuItem }}
          onClick={() => onTabPress(3)}
        >
          La vie de couple
        </MenuItem>
        <MenuItem
          classes={{ root: classes.menuItem }}
          onClick={() => onTabPress(3)}
        >
          La sexualité
        </MenuItem>
      </Menu>

      <Menu
        id="science-menu"
        classes={{ paper: classes.menuWrapper }}
        anchorEl={anchorEl}
        keepMounted
        open={menuIndexOpened === 4}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <MenuItem
          classes={{ root: classes.menuItem }}
          onClick={() => onTabPress(4)}
        >
          Science
        </MenuItem>
        <MenuItem
          classes={{ root: classes.menuItem }}
          onClick={() => onTabPress(4)}
        >
          La rencontre
        </MenuItem>
        <MenuItem
          classes={{ root: classes.menuItem }}
          onClick={() => onTabPress(4)}
        >
          La vie de couple
        </MenuItem>
        <MenuItem
          classes={{ root: classes.menuItem }}
          onClick={() => onTabPress(4)}
        >
          La sexualité
        </MenuItem>
      </Menu>
      <Menu
        id="histoire-menu"
        classes={{ paper: classes.menuWrapper }}
        anchorEl={anchorEl}
        keepMounted
        open={menuIndexOpened === 5}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <MenuItem
          classes={{ root: classes.menuItem }}
          onClick={() => onTabPress(5)}
        >
          Toutes les sous-catégories
        </MenuItem>
        <MenuItem
          classes={{ root: classes.menuItem }}
          onClick={() => onTabPress(5)}
        >
          La rencontre
        </MenuItem>
        <MenuItem
          classes={{ root: classes.menuItem }}
          onClick={() => onTabPress(5)}
        >
          La vie de couple
        </MenuItem>
        <MenuItem
          classes={{ root: classes.menuItem }}
          onClick={() => onTabPress(5)}
        >
          La sexualité
        </MenuItem>
      </Menu> */}
    </div>
  )
}
